import App from './App.vue';
import VueGtm from 'vue-gtm';
import * as Sentry from '@sentry/vue';
import appSetup from '@/utils/axiosInterceptors'
import extended from '@/utils/extendedFieldValidations'
import router from './router';
import store from './store';
import { createApp } from 'vue';
import { createGtag } from "vue-gtag";
import { configure } from 'vee-validate';
import { VueReCaptcha } from 'vue-recaptcha-v3'; 
import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css';
import './assets/tooltip.css';
import { createHead } from '@unhead/vue/client';

const app = createApp(App);

const gtag = createGtag({
  config: { id: window.config.GA_ID }
})

app.use(gtag);

const head = createHead();

app.use(VueGtm, {
  id: window.config.GTM_ID,
  debug: true,
  trackOnNextTick: false,
});

app.use(VueReCaptcha, {
  siteKey: window.config.RECAPTCHA_SITE_KEY,
  loaderOptions: {
    autoHideBadge: false, 
  }
});

app.use(FloatingVue, {
  themes: {
    'my-custom-tooltip': {
      $extend: 'tooltip', // Inherit from the default tooltip styles
    },
  },
});

configure({
  validateOnBlur: true,
  validateOnChange: true,
  validateOnInput: false,
  validateOnModelUpdate: true,
});

//  setup() function if needed
appSetup();

if (window.config.ENVIRONMENT !== 'local') {
  Sentry.init({
    app,
    dsn: window.config.SENTRY_DSN,
    // integrations: [new BrowserTracing()],  // Add BrowserTracing as an integration
    integrations: [Sentry.browserTracingIntegration()],  
    routingInstrumentation: Sentry.vueRouterInstrumentation(router),   // Move routing instrumentation setup here, accessing the function from @sentry/vue
    attachProps: true,
    logErrors: true,
    ignoreErrors: [
      "Blocked 'font' from 'data:'",
      'font-src',
      "Blocked 'font' from 'data:'"
    ],
    tracesSampleRate: window.config.SENTRY_TRACE_SAMPLE_RATE,
    tracingOptions: {
      trackComponents: true,
    },
    beforeSend(event) {
      const msg = event?.message;
      if (
        msg &&
        (
          msg.includes('font-src') ||
          msg.includes("Blocked 'font' from 'data:'") ||
          (msg.match(/font/i) && msg.match(/from/i) && msg.match(/data/i))
        )
      ) {
        console.log('Font Src error');
        console.log(event);
        return null;
      }
      return event;
    },
    environment: window.config.ENVIRONMENT
  });
}

extended.alphaNum();
extended.fieldRequired();
extended.minDate();
extended.minMax();
extended.max();
extended.monthBetween();
extended.specialChars();
extended.validYear();

//  Mount the app
app.use(head);
app.use(router);
app.use(store);
app.mount('#app');
